const capitalize = (s) => `${s[0].toUpperCase()}${s.slice(1)}`;
const uncapitalize = (s) => `${s[0].toLowerCase()}${s.slice(1)}`;
const getTestLabels = (componentName) => ({
    componentTestLabel: `${capitalize(componentName)}UIC`,
    elementTestLabel: (elementName) => `${uncapitalize(componentName)}${capitalize(elementName)}`,
});

export { getTestLabels };
//# sourceMappingURL=getTestLabels.js.map
